import { render } from "./AddDoctorConversational.vue?vue&type=template&id=16484134&scoped=true"
import script from "./AddDoctorConversational.vue?vue&type=script&lang=js"
export * from "./AddDoctorConversational.vue?vue&type=script&lang=js"

import "./AddDoctorConversational.vue?vue&type=style&index=0&id=16484134&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16484134"]])

export default __exports__